<template>
  <su-page>
    <el-row class="flex al-cn ju-sp mt30" slot="content">
<!--      v-if="token"-->
      <div class="testSiteApplication">
        <el-form ref="formData" :model="form" :rules="rules" label-width="80px">
<!--          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>-->
          <el-form-item label="联系方式" prop="mobile">
            <el-input type="number" v-model="form.mobile" placeholder="请输入"></el-input>
          </el-form-item>
<!--          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入"></el-input>
          </el-form-item>-->
          <el-form-item label="投诉内容" prop="detail">
            <el-input type="textarea" v-model="form.detail" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" :disabled="loading" type="primary" @click="submitForm()">提交</el-button>
            <el-button @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
<!--      <div class="testSiteApplication" v-else>
        <el-empty description="请登录后操作"></el-empty>
      </div>-->
    </el-row>
  </su-page>
</template>
<script>

import {create} from "@/api/api";
import {mapState} from "vuex";

export default {
  name: "complaint",
  data() {
    return {
      loading: false,
      form: {
        name: '',
        mobile: '',
        title: '',
        detail: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入联系方式', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (!(/^1[3456789]\d{9}$/.test(value))) {
                callback(new Error('请输入正确的手机号码'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        detail: [
          {required: true, message: '请输入投诉内容', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  mounted() {

  },
  created() {

  },
  methods: {
    // 提交表单
    submitForm() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.loading = true;
          create(this.form).then(res => {
            if (res.status === 200) {
              this.$message.success('提交成功');
              this.resetForm('formData');
              this.loading = false;
            }
          })
        } else {
          this.$message.warning('请填写必填项');
          return false;
        }
      });
    },
    // 重置表单
    resetForm() {
      this.$refs.formData.clearValidate(); //清除验证
      this.$refs.formData.resetFields(); //重置表单
    }
  }
}
</script>

<style scoped lang="scss">
@media (min-width: 750px) {
  .testSiteApplication {
    width: 50%;
  }
}

@media (max-width: 750px) {
  .testSiteApplication {
    width: 100%;
  }
}
</style>
